import { Injectable } from '@angular/core';

import { FileType } from '../models/file-item.model';
import { MruFileItem } from '../mru/mru-file-item.model';

export interface JumpListItem {
    application: string;
    fileName: string;
    fileType: FileType;
    fileTypeName: string;
    group: string;
    jumpListItemId: string;
    isLocal: boolean;
    url: string;
    canonicalUrl: string;
    lastShownTime: number;
    docId?: string;
    driveId?: string;
    isOnPremOrVanity?: boolean;
}

@Injectable()
export abstract class JumpListService {

    public abstract registerRecommendedJumpList(recommendedDocs: Array<MruFileItem>): void;

    public abstract registerRecentJumpList(recentDocs: Array<MruFileItem>): void;

    public abstract getJumpListItemById(id: string): JumpListItem;
}
